import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;

  @media (max-width: 768px) {
    gap: 16px;
    padding: 16px;
  }

  @media (max-width: 480px) {
    gap: 12px;
    padding: 12px;
  }
`

export const NoDataMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px;
  color: ${({ theme }) => theme.colors.text.secondary};
`
